export default "__VITE_ASSET__93031190__"